module.exports = __webpack_public_path__ + "img/cozette.17d83a9b.jpg";